const home = {
  'admin.home.hetmet': 'Home - Dashboard',
};

export default {
  ...home,
};
